import axios from 'axios'

// Get Campuses
const getCampuses = async () => {
  const response = await axios.get('/api/general/campuses-list')
  return response.data
}

// Start Impersonation
const startImpersonate = async ({data}) => {
  const response = await axios.post('/api/general/start-impersonate', data)
  return response.data
}

// Stop Impersonation
const stopImpersonate = async ({data}) => {
  const response = await axios.post('/api/general/stop-impersonate', data)
  return response.data
}

// Get Sections
const getSections = async () => {
  const response = await axios.get('/api/general/sections-list')
  return response.data
}

// Get ProgramLevels
const getProgramLevels = async () => {
  const response = await axios.get('/api/general/program-levels-list')
  return response.data
}

// Get Program Years
const getProgramYears = async () => {
  const response = await axios.get('/api/general/program-years-list')
  return response.data
}

// Get Programs
const getPrograms = async () => {
  const response = await axios.get('/api/general/programs-list')
  return response.data
}

// Get Genders
const getGenders = async () => {
  const response = await axios.get('/api/general/genders-list')
  return response.data
}

// Get Countries
const getCountries = async () => {
  const response = await axios.get('/api/general/countries-list')
  return response.data
}

// Get Courses
const getCourses = async (lang: string) => {
  const response = await axios.get(`/api/general/courses-list/${lang}`)
  return response.data
}

// Get RegulationCategories
const getRegulationCategories = async () => {
  const response = await axios.get('/api/general/regulation-categories-list')
  return response.data
}

//  getCurrencies
const getCurrencies = async () => {
  const response = await axios.get('/api/general/currencies-list')
  return response.data
}

//  getCampusCurrencies
const getCampusCurrencies = async () => {
  const response = await axios.get('/api/general/campus-currencies-list')
  return response.data
}

//  getAcademicYears
const getAcademicYears = async () => {
  const response = await axios.get('/api/general/academic-years-list')
  return response.data
}

//  getIntakes
const getIntakes = async () => {
  const response = await axios.get('/api/general/intakes-list')
  return response.data
}

//  getOrganizations
const getOrganizations = async () => {
  const response = await axios.get('/api/general/organizations-list')
  return response.data
}

//  getPublicationCategories
const getPublicationCategories = async () => {
  const response = await axios.get('/api/general/publication-categories-list')
  return response.data
}

//  getPublicationFields
const getPublicationFields = async () => {
  const response = await axios.get('/api/general/publication-fields-list')
  return response.data
}

//  getVideoCategories
const getVideoCategories = async () => {
  const response = await axios.get('/api/general/video-categories-list')
  return response.data
}

//  getFormType
const getFormType = async () => {
  const response = await axios.get('/api/general/form-types-list')
  return response.data
}

const getBanks = async () => {
  const response = await axios.get('/api/general/banks-list')
  return response.data
}

const getSemesters = async () => {
  const response = await axios.get('/api/general/semesters-list')
  return response.data
}

const getVideos = async () => {
  const response = await axios.get('/api/general/videos-list')
  return response.data
}

const getStudents = async () => {
  const response = await axios.get('/api/general/students-list')
  return response.data
}

const notifications = async () => {
  const response = await axios.get(`/api/general/notifications`)
  return response.data
}

const readNotification = async (id: string) => {
  const response = await axios.get(`/api/general/read-notification/${id}`)
  return response.data
}

const relatedNotification = async (id: string) => {
  const response = await axios.get(`/api/general/related-notifications/${id}`)
  return response.data
}

const generalStatistics = async () => {
  const response = await axios.get(`/api/general/general-statistics`)
  return response.data
}

const getOnlineProps = async (lang) => {
  const response = await axios.get(`/api/get-props/${lang}`)
  return response.data
}

const submitOnlineApplication = async ({data}) => {
  const response = await axios.post('/api/online-app-submit', data)
  return response.data
}

const getTimeSlots = async () => {
  const response = await axios.get(`/api/general/time-slots`)
  return response.data
}

const generalService = {
  getTimeSlots,
  submitOnlineApplication,
  getOnlineProps,
  generalStatistics,
  relatedNotification,
  readNotification,
  notifications,
  getStudents,
  getVideos,
  getCampuses,
  startImpersonate,
  stopImpersonate,
  getSections,
  getProgramLevels,
  getProgramYears,
  getPrograms,
  getGenders,
  getCountries,
  getCourses,
  getRegulationCategories,
  getCurrencies,
  getCampusCurrencies,
  getAcademicYears,
  getIntakes,
  getOrganizations,
  getPublicationCategories,
  getPublicationFields,
  getVideoCategories,
  getFormType,
  getBanks,
  getSemesters,
}

export default generalService
